<template>
      <div
      id="goEHR"
      @click="toEHR"
      style="position:fixed;z-index:1000;right:10px;bottom:20px;width:50px;height:50px;"
    >
        <el-tooltip class="item" effect="dark" content="点击填写：问题、建议、投诉" placement="top">
          <div class="imgicon" >
            <img src="./feedback.png" style="width:25px;height:25px" />
            <!-- <p>智能回复</p> -->
          </div>
        </el-tooltip>
  </div>
</template>
<script>
export default {
  data() {
    return {
      domMoved:false
    }
  },
  mounted() {
     const a = document.getElementById('goEHR')
     let drag = false
     const that = this
     a.onmousedown = function(e) {
       drag = true
       console.log(drag, e)
       that.domMoved = false
       document.onmousemove = function(e2) {
         if (drag) {
           a.style.left = `${e2.clientX - 30}px`
           a.style.top = `${e2.clientY - 30}px`
           setTimeout(() => {
             that.domMoved = true
           }, 300)
         }
       }
       // document.onmouseup = function(){
       //   console.log(1111)
       //   document.onmousemove = null
       //   document.onmouseup = null
       //   drag = false
       // }
     }
     a.onmouseup = function() {
       console.log('mouseup', drag, that.domMoved)
       drag = false
       setTimeout(() => {
         that.domMoved = false
       }, 10)
     }
   },
   methods:{
     toEHR() {
      if(this.domMoved) return
      // window.open(`https://organization.${process.env.NODE_ENV === 'production' ? 'suntekcorps' : 'sfc'}.com/feedback`, '_blank')
       // 测试的进测试   正式的进正式
      window.open(process.env.NODE_ENV === 'production' ? 'https://organization.suntekcorps.com/feedback' : 'http://organization.sfc.com/feedback', '_blank')

       // window.open('https://organization.suntekcorps.com/feedback', '_blank')
    }
   }
}

</script>
<style lang="scss" scoped>
.imgicon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  background: #f0c78a;
  display: flex;
  justify-content: center;
  align-items:  center;
  // 鼠标移入效果
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: scale(1.1);
  }
  overflow: hidden;
  img {
      pointer-events: none;
  }
}

</style>

